import { render, staticRenderFns } from "./MegaMenuWebComponent.vue?vue&type=template&id=453a9ede&shadow"
import script from "./MegaMenuWebComponent.vue?vue&type=script&lang=js&shadow"
export * from "./MegaMenuWebComponent.vue?vue&type=script&lang=js&shadow"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports